var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,5 L 30,5 M 0,15 L 12,15 M 18,15 L 30,15 M 0,25 L 30,25","strokeWidth":"4"}));
}

Menu.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = Menu;

Menu.default = Menu;
